import type { ToolbarItemsPropType } from '@public-ui/components';
import { KolToolbar } from '@public-ui/react-v19';
import type { FC } from 'react';
import React from 'react';
import { SampleBlock } from '../SampleBlock';
import { SampleDescription } from '../SampleDescription';

export const ToolbarBasic: FC = () => {
	const TOOLBAR_ITEMS: ToolbarItemsPropType = [
		{
			type: 'button',
			_label: 'Back',
			_hideLabel: true,
			_icons: {
				left: {
					icon: 'kolicon-chevron-left',
				},
			},
		},
		{
			type: 'button',
			_label: 'Next',
			_hideLabel: true,
			_icons: {
				right: {
					icon: 'kolicon-chevron-right',
				},
			},
		},
		{
			type: 'link',
			_href: '#/back-page',
			_label: 'Simple Link 1',
		},
		{
			type: 'link',
			_href: '#/back-page',
			_label: 'Simple Link 3',
		},
		{
			type: 'button',
			_label: 'Bold',
			_variant: 'secondary',
		},
		{
			type: 'button',
			_label: 'Delete',
			_icons: {
				right: {
					icon: 'kolicon-cross',
				},
			},
			_variant: 'danger',
		},
	];
	return (
		<>
			<SampleDescription>
				<p>
					KolToolbars renders a set of given control elements grouped into one toolbar where focus can be moved using the keyboard arrow keys. The sample
					features button and link elements.
				</p>
			</SampleDescription>

			<SampleBlock id="horizontal" heading="Orientation horizontal" fitContent narrow>
				<KolToolbar class="block w-fit" _label="Toolbar" _items={TOOLBAR_ITEMS} />
			</SampleBlock>

			<SampleBlock id="vertical" heading="Orientation vertical" fitContent>
				<KolToolbar class="block w-fit" _label="Toolbar" _items={TOOLBAR_ITEMS} _orientation="vertical" />
			</SampleBlock>
		</>
	);
};
